$('#login-form-link').click(function(e) {
    $("#login-form").delay(100).fadeIn(100);
    $("#register-form").fadeOut(100);
    $('#register-form-link').removeClass('active');
    $(this).addClass('active');
    e.preventDefault();
});
$('#register-form-link').click(function(e) {
    $("#register-form").delay(100).fadeIn(100);
    $("#login-form").fadeOut(100);
    $('#login-form-link').removeClass('active');
    $(this).addClass('active');
    e.preventDefault();
});

$(function() {
    $('.questionnaire-date').datepicker({
        onSelect: function(theDate) {
            $("#dataEnd").datepicker('option', 'minDate', new Date(theDate));
        },
        dateFormat: 'yy-mm-dd',
        firstDay: 1
    });
    //used for selects to set the input name to the components id
    $('.questionnaireselect').click(function() {
        var group = $( this ).data("groupid");
        $("#"+group).attr('name', $(this).attr('id'));
    });

});

//functions
function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 44 || charCode > 57) && ((charCode != 44 || charCode != 46) || charCode == 45)) {
        return false;
    }
    return true;
}



$(document).ready(function(){
    $('#createfolderbtn').click(function(){
        $('#createfolder').slideToggle('fast');
    });

    $("#select_all").change(function(){
        $(".cb").prop("checked", $(this).prop("checked"));
    });

    $('#usersearch').autocomplete({
        source: '/users/getjson',
        select: function(event, ui) {
            if(ui.item.id)
            {
                document.getElementById("user_id").value = ui.item.id;
                document.getElementById("usersearchbtn").disabled = 0;
            }
        }
    });

    $('#groupsearch').autocomplete({
        source: '/groups/getjson',
        select: function(event, ui) {
            if(ui.item.id)
            {
                document.getElementById("group_id").value = ui.item.id;
                document.getElementById("groupsearchbtn").disabled = 0;
            }
        }
    });

    $('#filesearch').autocomplete({
        source: '/files/searchfiles',
        select: function(event, ui) {
            if(ui.item.id)
            {
                let checkedGroups = [];
                [].forEach.call(document.querySelectorAll('input[class="groupselector"]:checked'), function(cb) {
                    checkedGroups.push(cb.value)
                });
                checkedGroups.forEach(function (groupId) {
                    axios.post('/files/grouphaspermission', {
                        checkedGroupId: groupId,
                        fileId: ui.item.id,
                    })
                        .then(function (response) {
                            if(response.data.value == 'false') {
                                alert(response.data.name + ' har inte tillgång till filen.');
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                });

                $("#news-filelisttable").append('<tr id="file_'+ui.item.id+'"><td>'+ui.item.name+'</td><td class="text-right"><button type="button" data-fileid="'+ui.item.id+'" class="btn btn-danger btn-sm" onClick="testfunc(this)"><i class="fa fa-trash"></i></button></td></tr>');
                $("#news_files").append('<input type="hidden" name="fileids[]" id="filehidden_'+ui.item.id+'" value="'+ui.item.id+'"/>');
            }
            $(this).val(''); return false;
        }
    });





    var customRenderMenu = function( ul, items ) {
        var self = this,
            currentCategory = "";
        $.each( items, function( index, item ) {
            if ( item.category != currentCategory ) {
                ul.append( "<li class='ui-autocomplete-category'>" + item.category + "</li>" );
                currentCategory = item.category;
            }
            self._renderItemData( ul, item );
        });
    }

    $( "#setnewsheader" ).click(function() {
        $("#news-filelistbtn").click();
    });

    $( "#news-filelistbtn" ).click(function() {
        $(this).addClass('active');
        $("#news-newslistbtn").removeClass('active');
        $("#news-newslist").hide();
        $("#news-filelist").show();
    });

    $( "#news-newslistbtn" ).click(function() {
        $(this).addClass('active');
        $("#news-filelistbtn").removeClass('active');
        $("#news-newslist").show();
        $("#news-filelist").hide();
    });



    $('#adminsearch').autocomplete({
        source: '/adminsearch',
        position: {  collision: "flip"  },
        select: function(event, ui) {
            window.location.href = ui.item.url;
        },
        create: function () {
            //access to jQuery Autocomplete widget differs depending
            //on jQuery UI version - you can also try .data('autocomplete')
            $(this).data('uiAutocomplete')._renderMenu = customRenderMenu;
        }

    });

    $('#datetime').datepicker({
        onSelect: function(theDate) {
            $("#dataEnd").datepicker('option', 'minDate', new Date(theDate));
        },
        dateFormat: 'yy-mm-dd',
        firstDay: 1
    });

    $('#show_signup').click(function(){
        $('#signup_hidden').slideToggle('fast');
        $(this).hide();
        $("#deny_signup").hide();
    });

    $('#add_show').click(function(){
        $(this).hide();
        $('#add_hidden').slideToggle('fast');
    });



    //autoupdate
    $(".componentgroup").change(function(){
        var form = $(this).closest("form");
        var url = $(form).attr('action');
        $.post( url, $(form).serialize() );
    });

    $(".componentpart").change(function(){
        var form = $(this).closest("form");
        var url = $(form).attr('action');
        $.post( url, $(form).serialize() );
    });



    tinymce.init({
        selector: '.tinymce',
        plugins: 'image link',
        image_title: true,
        automatic_uploads: true,
        file_picker_types: 'image',
        file_picker_callback: function(cb, value, meta) {
            var input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');

            // Note: In modern browsers input[type="file"] is functional without
            // even adding it to the DOM, but that might not be the case in some older
            // or quirky browsers like IE, so you might want to add it to the DOM
            // just in case, and visually hide it. And do not forget do remove it
            // once you do not need it anymore.

            input.onchange = function() {
                var file = this.files[0];

                var reader = new FileReader();
                reader.onload = function () {
                    // Note: Now we need to register the blob in TinyMCEs image blob
                    // registry. In the next release this part hopefully won't be
                    // necessary, as we are looking to handle it internally.
                    var id = 'blobid' + (new Date()).getTime();
                    var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                    var base64 = reader.result.split(',')[1];
                    var blobInfo = blobCache.create(id, file, base64);
                    blobCache.add(blobInfo);

                    // call the callback and populate the Title field with the file name
                    cb(blobInfo.blobUri(), { title: file.name });
                };
                reader.readAsDataURL(file);
            };

            input.click();
        },
        branding: false,
        menubar: false,
        controls: ['bold', 'italic', 'underline', 'strikethrough', '|', 'subscript', 'superscript', '|',
            'orderedlist', 'unorderedlist', '|', 'outdent', 'indent', '|', 'leftalign',
            'centeralign', 'rightalign', 'blockjustify', '|', 'unformat', '|', 'undo', 'redo', 'n',
            'font', 'size', 'style', '|', 'image', 'hr', 'link', 'unlink', '|', 'print'],
        toolbar: ' styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
        setup: function (editor) {
            editor.on('change', function () {
                $(tinyMCE.get(editor.id).getElement()).val(tinyMCE.get(editor.id).getContent());
                $(tinyMCE.get(editor.id).getElement()).trigger('change');

            }); }
    });

    $('#email_on_answer').change(function(){
        if($(this).prop('checked')){
            $('#response_email').show();
        }else{
            $('#response_email').hide();
        }
    });

});






// WEBPACK FOOTER //
// ./resources/assets/js/functions.js